/*/*import ProductCollectionAttachedDto from './productcollectionattachedDto';*/
import Specification from './specification'
import SpecificationCategory from './specificationCategory'
import SkuList from './skuList'
export default class ProductDetailExpandDto {
    brandId: string;
    mallGoodsNum: number;
    estimatedDays: number;
    stock: number;
    id: number;
    vedioUrl: string;
    shopId: string;
    sellerId: string;
    /// <summary>
    /// ��Դ
    /// </summary>
    //Source:Array<string>

    /// <summary>
    /// ��������
    /// </summary>
    detailUrl: string;

    /// <summary>
    /// ��ƷId
    /// </summary>
    goodsId: string;
    /// <summary>
    /// ����
    /// </summary>
    name: string;

    /// <summary>
    /// ��ͼ
    /// </summary>
    mainImgUrl: string;

    /// <summary>
    /// ����
    /// </summary>
    language: string;

    /// <summary>
    /// ������
    /// </summary>
    ship: string;

    /// <summary>
    /// �۸�
    /// </summary>
    price: number;

    /// <summary>
    /// ����
    /// </summary>
    sell: number;
    shipDay: number;
    isMianYou: boolean;
    creationTime?: Date;
    lastModificationTime?: Date;
    isGlobal: boolean;
    description: string;

    dimensions: string;
    carouselImgUrl: Array<string>;
    detailImgUrl: Array<string>;
    specification: Array<Specification>
    specificationCategory: Array<SpecificationCategory>
    skuList: Array<SkuList>
    constructor() {
        this.carouselImgUrl = [];
        this.detailImgUrl = [];
    }
}